import { render, staticRenderFns } from "./VendorCard.vue?vue&type=template&id=07edee78&scoped=true"
import script from "./VendorCard.vue?vue&type=script&lang=js"
export * from "./VendorCard.vue?vue&type=script&lang=js"
import style0 from "./VendorCard.vue?vue&type=style&index=0&id=07edee78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07edee78",
  null
  
)

export default component.exports